import { SEARCH_ZONES_KEYS } from 'components/constants/Constants';
import { AwardLevel } from 'types/global';
import { Award } from 'types/Search';
//the maximum number of icons to show in a row
const MAXIMUM_ICON_PER_ROW = 5;
// the maximum number of awards to show in a row if there are 3 or more certifications
const MAXIMUM_AWARD_PER_ROW = 2;
// the maximum number of certifications to show in a row if there are 2 or more awards
const MAXIMUM_CERTIFICATION_PER_ROW = 3;
export const getSortedAwardsArray = (awards: Award[]) =>
  ///  Award winner (gold, silver, bronze) > award nominee > sustainability zone > innovation zone
  [...awards].sort((a, b) => {
    if (b.year !== a.year) return b.year - a.year;

    const score = (award: Award) =>
      award.winner
        ? award.prize_level === AwardLevel.GOLD
          ? 6
          : award.prize_level === AwardLevel.SILVER
          ? 5
          : award.prize_level === AwardLevel.BRONZE
          ? 4
          : 3
        : award.shortlisted
        ? 2
        : award.category?.key === SEARCH_ZONES_KEYS.SUSTAINABILITY_ZONE
        ? 1.1
        : award.category?.key === SEARCH_ZONES_KEYS.INNOVATION_ZONE
        ? 1.05
        : 1;

    return score(b) - score(a);
  });

export const getNumberOfIcons = (
  arrayLength: number,
  count: number,
  type: 'AWARD' | 'CERTIFICATION'
) => {
  const lengthLimit =
    type === 'AWARD'
      ? count > MAXIMUM_CERTIFICATION_PER_ROW
        ? MAXIMUM_CERTIFICATION_PER_ROW
        : count
      : count > MAXIMUM_AWARD_PER_ROW
      ? MAXIMUM_AWARD_PER_ROW
      : count;

  const availableSlots = MAXIMUM_ICON_PER_ROW - lengthLimit;
  const hasOverflow = arrayLength > availableSlots;
  const numberOfIconsToShow = hasOverflow
    ? availableSlots - 1 // leave space for "+N"
    : arrayLength;

  return numberOfIconsToShow;
};
